import styled from 'styled-components';

export const AuthContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 30px auto;
  width: 900px;
`;
